<template>
  <div class="device-link">
    <!-- activation code -->
    <div v-if="errorMessage.length === 0 && !activationStatus" class="center-container">
      <div class="left">
        <img src="../assets/images/devices.png"/>
      </div>

      <div class="right">
        <div class="title">
          Link This Device
        </div>

        <div class="instructions">
          From your phone, PC, or tablet go to:
        </div>

        <div class="url">
          powerslide.app/activate
        </div>

        <div class="code-title">
          Then, enter this code:
        </div>

        <div class="code">
          {{ activationCode }}
        </div>

        <div class="button" @click="resetActivationCode">
          Reset Code
        </div>
      </div>
    </div>

    <div v-if="errorMessage.length === 0 && !activationStatus" class="update">
      This page will automatically update if linking is successful.
    </div>

    <!-- device activated -->
    <div v-if="errorMessage.length === 0 && activationStatus" class="center-container">
      <div class="left">
        <img src="../assets/images/devices.png"/>
      </div>

      <div class="right">
        <div class="title">Device activated</div>
        <button class="button" @click="$router.replace('/dashboard')">home</button>
      </div>
    </div>

    <!-- Error messages -->
    <div v-if="errorMessage.length > 0" class="center-container">
      <div class="left">
        <img src="../assets/images/devices.png"/>
      </div>
      <div class="right">
        <div class="error">
          <p>{{ errorMessage }}</p>
          <button class="button" @click="$router.replace('/dashboard')">home</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import axios from 'axios'
import { getPersistentId } from '../utils/hash'

export default {
  name: 'DeviceLink',
  data () {
    return {
      deviceId: '',
      activationCode: '',
      maxDevicesReached: false,
      resetInterval: -1,
      resetTimeout: 5 * 60 * 1000,
      pollingInterval: 10 * 1000,
      pollingStarted: -1,
      timePassed: -1,
      activationStatus: false,
      errorMessage: ''
    }
  },
  computed: {
    persistentDeviceId () {
      return getPersistentId()
    }
  },
  async mounted () {
    try {
      await this.requestActivationCode()
      this.startPollingActivationStatus()
    } catch (error) {
      const status = error.response.status
      this.errorMessage = error.response.data.message || error.response.data
      this.stopPollingActivationStatus()
      if (status === 400) {
        this.maxDevicesReached = true
      }
    }
  },
  methods: {
    pollingHasExpired () {
      return this.pollingTimePassed() >= this.resetTimeout
    },
    pollingTimePassed () {
      return new Date().getTime() - this.pollingStarted
    },
    async resetActivationCode () {
      if (this.pollingHasExpired()) {
        await this.requestActivationCode()
        this.startPollingActivationStatus()
      }
    },
    async requestActivationCode () {
      const { data } = await axios.get(`/api/devices/activation_code?persistent_device_id=${this.persistentDeviceId}`)
      const { data: { _id: deviceId, activation_code: activationCode } } = data
      this.deviceId = deviceId
      this.activationCode = activationCode.toUpperCase()
    },
    async getActivationStatus () {
      const { data } = await axios.get(`/api/devices/${this.deviceId}/status`)
      return data
    },
    startPollingActivationStatus () {
      console.log('startPollingActivationStatus')
      this.pollingStarted = new Date().getTime()
      this.resetInterval = setInterval(async () => {
        // get activation status
        const { data: { activation_status: activationStatus } } = await this.getActivationStatus()
        this.activationStatus = activationStatus

        // check if polling exceeds reset period
        if (this.pollingHasExpired() || this.activationStatus) {
          this.stopPollingActivationStatus()
        }
      }, this.pollingInterval)
    },
    stopPollingActivationStatus () {
      console.log('stopPollingActivationStatus')
      clearInterval(this.resetInterval)
      this.timePassed = -1
      this.pollingStarted = -1
      this.resetInterval = -1
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 36px;
    margin-top: 20px;
    padding: 12px 22px;
  }

  .code {
    font-size: 108px;
  }

  .code-title {
    font-size: 36px;
    margin-top: 50px;
  }

  .center-container {
    left: 50%;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1500px;
  }

  .device-link {
    background: #282828;
    color: white;
    height: 100vh;
    width: 100vw;
  }

  .instructions {
    margin-top: 40px;
    font-size:  40px;
    font-weight: 100;
  }

  .left {
    float: left;
    position: relative;
  }

  .right {
    float: right;
    position: relative;
  }

  .title {
    font-size: 48px;
  }

  .update {
    bottom: 40px;
    font-size: 28px;
    position: absolute;
    text-align: center;
    width: 100%;
  }

  .url {
    font-size: 60px;
    font-weight: bold;
    margin-top: 20px;
  }

  .error {
    font-size: 24px;
  }
</style>
